// auth.interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HttpResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '@env/environment'; // 🔹 adjust path
import { EncryptedStorageService } from '@elan/services/encrypted-storage.service';
import { getErrorMessage } from '@elan/services/errorMessage';
import { ToastService } from '@elan/services/toast.service';
import { Router } from '@angular/router';
import { SnackbarService } from '../snackbar.service';
import { MatDialog } from '@angular/material/dialog';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private encryptedStorageService: EncryptedStorageService,
    private toastService: ToastService,
    private router: Router,
    private snackService: SnackbarService,
    private dialog: MatDialog
  ) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let apiReq = req;

    // 🔹 Prepend base URL if request URL is relative
    if (!req.url.startsWith('http')) {
      apiReq = req.clone({
        url: environment.apiUrl + req.url
      });
    }

    // 🔹 Attach token if available
    const token: any = this.encryptedStorageService.getItem('token');

    if (token?.data?.access_token) {
      apiReq = apiReq.clone({
        setHeaders: { Authorization: `Bearer ${token?.data?.access_token}` }
      });
    }

    // 🔹 Response interception
    return next.handle(apiReq).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        let errorMessage = getErrorMessage(error);
        this.toastService.clearAll();
        this.snackService.error(errorMessage);

        if (error.status === 401) {
          // Close all open Material dialogs before redirecting
          this.dialog.closeAll();

          this.encryptedStorageService.removeItem('token');
          this.router.navigate(['/signin'], { queryParams: { return_url: this.router.url } });
        }
        return throwError(() => error);
      })
    );
  }

}
